/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Hide_AgendaInputs */

const cs_calendar_hide_agenda = /** @type {(inputs: Calendar_Hide_AgendaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrýt agendu`)
};

const en_calendar_hide_agenda = /** @type {(inputs: Calendar_Hide_AgendaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide agenda`)
};

/**
* | output |
* | --- |
* | "Hide agenda" |
*
* @param {Calendar_Hide_AgendaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_hide_agenda = /** @type {((inputs?: Calendar_Hide_AgendaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Hide_AgendaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_hide_agenda(inputs)
	return cs_calendar_hide_agenda(inputs)
});